import InputCheckboxGroupWithLabelAndValidation from './InputCheckboxGroupWithLabelAndValidation'

export default InputCheckboxGroupWithLabelAndValidation
